import script from "./pro.vue?vue&type=script&setup=true&lang=js"
export * from "./pro.vue?vue&type=script&setup=true&lang=js"

import "./pro.vue?vue&type=style&index=0&id=e18d3ff6&lang=scss&scoped=true"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e18d3ff6"]])

export default __exports__